export default __webpack_public_path__ + "static/images/touristVideoThumb.ad39a80e.png";